import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const ItineraryHeader = ({ activeDay, onDayChange, totalDays = 15, onMapClick }) => {
  const navigate = useNavigate();

  return (
    <header className="itinerary-header text-center mt-3">
      <h1>Day {activeDay} Itinerary</h1>

      {/* Day Navigation Buttons */}
      <div className="day-nav-container d-flex justify-content-center mt-3">
        {Array.from({ length: totalDays }, (_, i) => (
          <Button
            key={i + 1}
            className={`day-button mx-1 ${activeDay === i + 1 ? "active" : ""}`}
            style={{
              backgroundColor: activeDay === i + 1 ? "#00aeef" : "#fff",
              color: activeDay === i + 1 ? "#fff" : "black",
              border: "2px solid #00aeef",
            }}
            onClick={() => {
              onDayChange(i + 1); // Update active day
              navigate(`/day/${i + 1}`); // Navigate to the appropriate page
            }}
          >
            Day {i + 1}
          </Button>
        ))}

        <Button
          className="map-button mx-2"
          variant="light"
          onClick={onMapClick} // Open Map Modal
          style={{
            backgroundColor: "white",
            color: "black",
            borderRadius: "20px",
            border: "2px solid #00aeef",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            className="bi bi-map"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M15.817.113A.5.5 0 0 1 16 .5v14a.5.5 0 0 1-.402.49l-5 1a.5.5 0 0 1-.196 0L5.5 15.01l-4.902.98A.5.5 0 0 1 0 15.5v-14a.5.5 0 0 1 .402-.49l5-1a.5.5 0 0 1 .196 0L10.5.99l4.902-.98a.5.5 0 0 1 .415.103M10 1.91l-4-.8v12.98l4 .8zm1 12.98 4-.8V1.11l-4 .8zm-6-.8V1.11l-4 .8v12.98z"
            />
          </svg>
        </Button>
      </div>
    </header>
  );
};

export default ItineraryHeader;
